(function(){
  // Toggle langs
  var $langs = document.querySelectorAll('.js-langs');
  if ($langs.length) {
    $langs.forEach(function($lang) {
      var $activeLang = $lang.querySelector('.js-active-lang');
      $activeLang.addEventListener('click', function(e) {
        e.preventDefault();
      });
      $lang.addEventListener('click', function() {
        $lang.classList.toggle('is-opened');
      });
    });
  }
})();
